import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import optainScanningImg from 'src/assets/img/optain-scanning.png';

import { I18NextNS } from 'src/models/Language.model';

interface ImagingInProgressProps {
  id?: string;
  onDragOver?: React.DragEventHandler<HTMLImageElement>;
  onDrop?: React.DragEventHandler<HTMLImageElement>;
}

const ImagingInProgress = ({
  id,
  onDragOver,
  onDrop,
}: ImagingInProgressProps) => {
  const { t } = useTranslation(I18NextNS.PAGES, { keyPrefix: 'newExam' });
  return (
    <Container className="position-relative p-0 border-0">
      <img
        src={optainScanningImg}
        alt={t('imagingInProgress')}
        className="img-fluid"
        style={{
          width: '4096px',
          maxHeight: window.innerWidth > 2000 ? '60vh' : '43vh',
          objectFit: 'contain',
        }}
        id={id}
        onDragOver={onDragOver}
        onDrop={onDrop}
        draggable={false}
      />

      <div
        className="position-absolute start-50 translate-middle text-white text-center pe-none"
        style={{ top: '60%' }}
      >
        {t('imagingInProgress')}
      </div>
    </Container>
  );
};
export default ImagingInProgress;
